import React from "react";
import styled from "@emotion/styled";
import Icon from "~/core/scripts/components/Icon";

export const CenterOnDesktop = styled.div`
  ${(p) => p.theme.breakpoints.sm.up} {
    text-align: center;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  background: #f9f9f9;
  padding: 24px 0;
`;

export const BarsWrapper = styled.figure`
  margin: 0;
  display: flex;
`;

export const Bar = styled.div`
  flex-grow: ${({ width, isPopularVote }) =>
    isPopularVote ? width / 1000000 : width};
  transition: flex 250ms;
  position: relative;
  height: 48px;
  background-color: ${({ candidate, theme }) =>
    candidate === "Clinton"
      ? theme.colors.democratic
      : theme.colors.republican};
`;

export const BarsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const Candidate = styled.div`
  flex-basis: 100px;
  flex-grow: 0;
  ${({ rightAligned }) =>
    rightAligned &&
    `
    text-align: right;
  `}
`;

export const BarsLabel = styled.div`
  flex-grow: 1;
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 8px;
  line-height: 1.1;
  color: ${({ theme }) => theme.colors.black};
`;

export const Name = styled.h6`
  margin: 0 0 8px;
  font-weight: bold;
  font-size: 16px;
  line-height: 1.1;
  color: ${({ theme, party }) =>
    party === "democratic" ? theme.colors.democratic : theme.colors.republican};
`;

export const Head = styled.img`
  width: 40px;
  height: auto;
`;

export const BarsFooter = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
`;

export const Middle = styled.div`
  flex-grow: 1;
  text-align: center;
  font-size: 12px;
  line-height: 1.1;
  margin-top: -4px;
  color: ${({ theme }) => theme.colors.grey40};
`;

export const Sum = styled.div`
  font-size: 14px;
  flex-basis: 80px;
  line-height: 1.1;

  ${({ rightAligned }) =>
    rightAligned &&
    `
    text-align: right;
  `}
`;

export const ElectedCheck = styled(Icon)`
  opacity: 0;
  transition: opacity 500ms 250ms;
`;
